import { render, staticRenderFns } from "./box-code-download-modal.vue?vue&type=template&id=8695668c"
import script from "./box-code-download-modal.vue?vue&type=script&lang=js"
export * from "./box-code-download-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports